import script from "./BotaoComponente.vue?vue&type=script&setup=true&lang=js"
export * from "./BotaoComponente.vue?vue&type=script&setup=true&lang=js"

import "./BotaoComponente.vue?vue&type=style&index=0&id=4e05bbc6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e05bbc6"]])

export default __exports__